import { useField } from "formik";
import React from "react";
import { DateInput } from "semantic-ui-calendar-react";
import { Form } from "semantic-ui-react";

const DatePicker = ({ label, ...props }: any) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [field, meta, helpers] = useField(props);

  const handleChange = (
    event: React.SyntheticEvent<HTMLElement, Event>,
    { name, value }: any
  ) => {
    helpers.setValue(value);
  };

  return (
    <Form.Field>
      {label && <label>{label}</label>}
      <DateInput
        name={field.name}
        value={field.value}
        iconPosition='left'
        dateFormat='YYYY-MM-DD'
        onChange={handleChange}
      />
    </Form.Field>
  );
};

export default DatePicker;
